import { Button } from "antd";
import React from "react";
import { useSelector } from "react-redux";
import "./index.css";

interface IModalFooterProps {
  onOtpModalFooterSubmit: () => void;
  isResendActive?: boolean;
  buttonLabel: string;
  counter: number;
  onResend: () => void;
}

const OTPInputModalFooter: React.FC<IModalFooterProps> = ({
  onOtpModalFooterSubmit,
  buttonLabel,
}) => {
  const loading: boolean = useSelector(
    (state: any) => state.loader.searchLoader
  );
  return (
    <div className="footerRoot">
      <Button
        className="commonButtonBackground primaryButton formItemButton"
        loading={loading}
        onClick={onOtpModalFooterSubmit}
      >
        {buttonLabel}
      </Button>
    </div>
  );
};

export default OTPInputModalFooter;
